import { envConfig } from './env';

export const FEATURE_FLAGS = {
    checkout: {
        giftcards: isFeatureEnabled(
            envConfig.NEXT_PUBLIC_FEATURES_CHECKOUT_GIFTCARDS,
        ),
        adyen: isFeatureEnabled(envConfig.NEXT_PUBLIC_FEATURES_CHECKOUT_ADYEN),
        walley: isFeatureEnabled(
            envConfig.NEXT_PUBLIC_FEATURES_CHECKOUT_WALLEY,
        ),
        giftCardChangeButton: isFeatureEnabled(
            envConfig.NEXT_PUBLIC_FEATURES_CHECKOUT_GIFTCARDS_CHANGE_BUTTON,
        ),
        madeToOrderNotification: isFeatureEnabled(
            envConfig.NEXT_PUBLIC_FEATURES_CHECKOUT_MADE_TO_ORDER,
        ),
    },
    customerService: {
        emailLink: isFeatureEnabled(
            envConfig.NEXT_PUBLIC_FEATURES_CUSTOMER_SERVICE_EMAIL_LINK,
        ),
        phoneLink: isFeatureEnabled(
            envConfig.NEXT_PUBLIC_FEATURES_CUSTOMER_SERVICE_PHONE_LINK,
        ),
        imboxButton: isFeatureEnabled(
            envConfig.NEXT_PUBLIC_FEATURES_CUSTOMER_SERVICE_IMBOX_BUTTON,
        ),
    },
    discountPopup: {
        show: isFeatureEnabled(
            envConfig.NEXT_PUBLIC_FEATURES_SHOW_DISCOUNT_POPUP,
        ),
    },
    searchEngine: {
        exploded: isFeatureEnabled(
            envConfig.NEXT_PUBLIC_FEATURES_SEARCH_ENGINE_EXPLODE_PRODUCTS,
        ),
    },
    product: {
        newProductPage: isFeatureEnabled(
            envConfig.NEXT_PUBLIC_FEATURES_PRODUCT_NEW_PRODUCT_PAGE,
        ),
        contentfulParametrics: isFeatureEnabled(
            envConfig.NEXT_PUBLIC_FEATURES_PRODUCT_CONTENTFUL_PARAMETRICS,
        ),
        newProductGallery: isFeatureEnabled(
            envConfig.NEXT_PUBLIC_FEATURES_PRODUCT_NEW_GALLERY,
        ),
        googleAutomatedDiscounts: isFeatureEnabled(
            envConfig.NEXT_PUBLIC_FEATURES_GOOGLE_AUTOMATED_DISCOUNTS,
        ),
    },
    products: {
        swatches: isFeatureEnabled(
            envConfig.NEXT_PUBLIC_FEATURES_PRODUCTS_SWATCHES,
        ),
        videos: isFeatureEnabled(
            envConfig.NEXT_PUBLIC_FEATURES_PRODUCTS_VIDEOS,
        ),
        staticPages: isFeatureEnabled(
            envConfig.NEXT_PUBLIC_FEATURES_STATIC_PRODUCT_PAGES,
        ),
    },
    marketSelector: {
        new: isFeatureEnabled(
            envConfig.NEXT_PUBLIC_FEATURES_NEW_MARKET_SELECTOR,
        ),
    },
    cache: {
        loop: isFeatureEnabled(envConfig.NEXT_PUBLIC_FEATURES_CACHE_LOOP),
    },
    datadog: {
        rum: isFeatureEnabled(envConfig.NEXT_PUBLIC_DATADOG_RUM),
    },
    next: {
        prefetch: isFeatureEnabled(
            envConfig.NEXT_PUBLIC_FEATURES_LINK_PREFETCH,
        ),
    },
    elevate: isFeatureEnabled(envConfig.NEXT_PUBLIC_FEATURES_ELEVATE),
} as const;

function isFeatureEnabled(value?: string) {
    const compare = value?.localeCompare('true', undefined, {
        sensitivity: 'accent',
    });

    return compare === 0;
}
